var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconsCreditCard = function SvgIconsCreditCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.25 4c1.463 0 2.658 1.107 2.745 2.504l.005.163v10.666c0 1.419-1.142 2.578-2.582 2.662L20.25 20H3.75c-1.463 0-2.658-1.107-2.745-2.504L1 17.333V6.667c0-1.419 1.142-2.578 2.582-2.662L3.75 4h16.5zm.917 7.2H2.833v6.133a.9.9 0 0 0 .81.883l.107.006h16.5c.47 0 .858-.343.91-.785l.007-.104V11.2zm-.917-5.422H3.75a.907.907 0 0 0-.91.785l-.007.104v2.577h18.334V6.667a.9.9 0 0 0-.81-.883l-.107-.006z"
  })));
};
export default SvgIconsCreditCard;